import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLangPath } from "@/i18n/LangLayout";
import logo from "@/assets/logo.webp";

export const Footer = () => {
  const { t } = useTranslation();
  const lp = useLangPath();

  return (
    <footer className="bg-primary text-primary-foreground mt-12 sm:mt-20">
      <div className="container py-10 sm:py-16 grid sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 text-center md:text-right">
        <div className="md:col-span-1">
          <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
            <img src={logo} alt={t("common.siteName")} className="w-14 h-14 object-contain" />
            <div>
              <div className="font-heading font-bold">{t("common.siteName")}</div>
              <div className="text-xs opacity-70">{t("common.tagline")}</div>
            </div>
          </div>
          <p className="text-sm opacity-80 leading-relaxed">{t("footer.description")}</p>
        </div>

        <div>
          <h2 className="font-heading font-bold mb-4 text-accent text-base">{t("footer.practiceTitle")}</h2>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to={lp("/practice/personal-injury")} className="hover:text-accent transition-smooth">{t("practices.personalInjury.title")}</Link></li>
            <li><Link to={lp("/practice/labor-law")} className="hover:text-accent transition-smooth">{t("practices.laborLaw.title")}</Link></li>
            <li><Link to={lp("/practice/social-security")} className="hover:text-accent transition-smooth">{t("practices.socialSecurity.title")}</Link></li>
            <li><Link to={lp("/practice/medical-negligence")} className="hover:text-accent transition-smooth">{t("practices.medicalNegligence.title")}</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-heading font-bold mb-4 text-accent text-base">{t("footer.navTitle")}</h2>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to={lp("/about")} className="hover:text-accent transition-smooth">{t("nav.about")}</Link></li>
            <li><Link to={lp("/media")} className="hover:text-accent transition-smooth">{t("nav.media")}</Link></li>
            <li><Link to={lp("/blog")} className="hover:text-accent transition-smooth">{t("nav.blog")}</Link></li>
            <li><Link to={lp("/contact")} className="hover:text-accent transition-smooth">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-heading font-bold mb-4 text-accent text-base">{t("footer.contactTitle")}</h2>
          <ul className="space-y-3 text-sm opacity-90">
            <li className="flex items-center justify-center md:justify-start gap-2"><Phone className="w-4 h-4 text-accent shrink-0" /><a href="tel:0505380626" dir="ltr">050-538-0626</a></li>
            <li className="flex items-center justify-center md:justify-start gap-2"><Mail className="w-4 h-4 text-accent shrink-0" /><a href="mailto:nizar@assi.org.il">nizar@assi.org.il</a></li>
            <li className="flex items-center justify-center md:justify-start gap-2"><MapPin className="w-4 h-4 text-accent shrink-0" />{t("contact.addressCard")}: רח׳ הסדנה 6, כפר סבא</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container py-5 text-center text-xs opacity-80 leading-relaxed space-y-2">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link to={lp("/accessibility")} className="hover:text-accent transition-smooth">{t("footer.accessibilityLink")}</Link>
            <span className="opacity-40">|</span>
            <Link to={lp("/terms")} className="hover:text-accent transition-smooth">{t("footer.termsLink")}</Link>
          </div>
          <div className="opacity-70">
            <span>{t("footer.rights")} © {new Date().getFullYear()} {t("common.siteName")}.</span>
            <span className="hidden sm:inline"> | </span>
            <span className="block sm:inline">{t("footer.disclaimer")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
